import Phaser from 'phaser'
import { Background } from '../base/background'
import { KENO_SNAKES_ATLAS_FRAMES, KENO_SNAKES_TEXTURE_KEYS } from './constants'

export class KenoSnakesBackground extends Background {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
  }

  createBackground() {
    const background = this.scene.add.image(
      0,
      0,
      KENO_SNAKES_TEXTURE_KEYS.ATLAS,
      KENO_SNAKES_ATLAS_FRAMES.GRID_BACKGROUND,
    )
    this.add(background)
  }
}
